import Vue from 'vue';

// Использовать только для связывания vue<->backbone. Не использовать внутри vue
export default new Vue();